import { render } from "./AppModules.vue?vue&type=template&id=6158056c"
const script = {}

import "./AppModules.vue?vue&type=style&index=0&id=6158056c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__